export interface Language {
  code: string;
  name: string;
  native: string;
}

export const TMDB_LANGUAGES: Language[] = [
  { code: 'en-US', name: 'English', native: 'English' },
  { code: 'id-ID', name: 'Indonesian', native: 'Bahasa Indonesia' },
  { code: 'ja-JP', name: 'Japanese', native: '日本語' },
  { code: 'ko-KR', name: 'Korean', native: '한국어' },
  { code: 'zh-CN', name: 'Chinese (Simplified)', native: '简体中文' },
  { code: 'zh-TW', name: 'Chinese (Traditional)', native: '繁體中文' },
  { code: 'es-ES', name: 'Spanish', native: 'Español' },
  { code: 'fr-FR', name: 'French', native: 'Français' },
  { code: 'de-DE', name: 'German', native: 'Deutsch' },
  { code: 'it-IT', name: 'Italian', native: 'Italiano' },
  { code: 'pt-BR', name: 'Portuguese (Brazil)', native: 'Português (Brasil)' },
  { code: 'pt-PT', name: 'Portuguese (Portugal)', native: 'Português (Portugal)' },
  { code: 'ru-RU', name: 'Russian', native: 'Русский' },
  { code: 'ar-SA', name: 'Arabic', native: 'العربية' },
  { code: 'hi-IN', name: 'Hindi', native: 'हिन्दी' },
  { code: 'th-TH', name: 'Thai', native: 'ไทย' },
  { code: 'vi-VN', name: 'Vietnamese', native: 'Tiếng Việt' },
  { code: 'tr-TR', name: 'Turkish', native: 'Türkçe' },
  { code: 'pl-PL', name: 'Polish', native: 'Polski' },
  { code: 'nl-NL', name: 'Dutch', native: 'Nederlands' },
  { code: 'sv-SE', name: 'Swedish', native: 'Svenska' },
  { code: 'da-DK', name: 'Danish', native: 'Dansk' },
  { code: 'fi-FI', name: 'Finnish', native: 'Suomi' },
  { code: 'nb-NO', name: 'Norwegian', native: 'Norsk' },
  { code: 'cs-CZ', name: 'Czech', native: 'Čeština' },
  { code: 'el-GR', name: 'Greek', native: 'Ελληνικά' },
  { code: 'hu-HU', name: 'Hungarian', native: 'Magyar' },
  { code: 'ro-RO', name: 'Romanian', native: 'Română' },
  { code: 'uk-UA', name: 'Ukrainian', native: 'Українська' },
  { code: 'he-IL', name: 'Hebrew', native: 'עברית' },
  { code: 'ms-MY', name: 'Malay', native: 'Bahasa Melayu' },
  { code: 'tl-PH', name: 'Filipino', native: 'Filipino' },
  { code: 'bn-BD', name: 'Bengali', native: 'বাংলা' },
  { code: 'ta-IN', name: 'Tamil', native: 'தமிழ்' },
  { code: 'te-IN', name: 'Telugu', native: 'తెలుగు' },
  { code: 'mr-IN', name: 'Marathi', native: 'मराठी' },
  { code: 'gu-IN', name: 'Gujarati', native: 'ગુજરાતી' },
  { code: 'kn-IN', name: 'Kannada', native: 'ಕನ್ನಡ' },
  { code: 'ml-IN', name: 'Malayalam', native: 'മലയാളം' },
  { code: 'si-LK', name: 'Sinhala', native: 'සිංහල' },
  { code: 'ne-NP', name: 'Nepali', native: 'नेपाली' },
  { code: 'my-MM', name: 'Burmese', native: 'မြန်မာ' },
  { code: 'ka-GE', name: 'Georgian', native: 'ქართული' },
  { code: 'hy-AM', name: 'Armenian', native: 'Հայերեն' },
  { code: 'kk-KZ', name: 'Kazakh', native: 'Қазақ' },
  { code: 'uz-UZ', name: 'Uzbek', native: "O'zbek" },
  { code: 'sq-AL', name: 'Albanian', native: 'Shqip' },
  { code: 'hr-HR', name: 'Croatian', native: 'Hrvatski' },
  { code: 'sk-SK', name: 'Slovak', native: 'Slovenčina' },
  { code: 'sl-SI', name: 'Slovenian', native: 'Slovenščina' },
  { code: 'sr-RS', name: 'Serbian', native: 'Српски' },
  { code: 'bs-BA', name: 'Bosnian', native: 'Bosanski' },
  { code: 'bg-BG', name: 'Bulgarian', native: 'Български' },
  { code: 'et-EE', name: 'Estonian', native: 'Eesti' },
  { code: 'lv-LV', name: 'Latvian', native: 'Latviešu' },
  { code: 'lt-LT', name: 'Lithuanian', native: 'Lietuvių' },
  { code: 'sw-KE', name: 'Swahili', native: 'Kiswahili' },
  { code: 'af-ZA', name: 'Afrikaans', native: 'Afrikaans' },
  { code: 'ca-ES', name: 'Catalan', native: 'Català' },
  { code: 'eu-ES', name: 'Basque', native: 'Euskara' },
  { code: 'gl-ES', name: 'Galician', native: 'Galego' },
];

export function getLanguageByCode(code: string): Language | undefined {
  return TMDB_LANGUAGES.find((l) => l.code === code);
}

export function getLanguageName(code: string): string {
  const lang = getLanguageByCode(code);
  return lang ? lang.native : code;
}
